import { render, staticRenderFns } from "./ViewJobResources.vue?vue&type=template&id=4db7c0e9&scoped=true&"
import script from "./ViewJobResources.vue?vue&type=script&lang=js&"
export * from "./ViewJobResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7c0e9",
  null
  
)

export default component.exports